import { FC } from 'react';
import { Box } from '@mui/material';

import styles from './TypingIndicator.module.scss';
import { AIRobotIcon } from '../../../../../../../components/Icons';

interface TypingIndicatorProps {
  className?: string;
}

const TypingIndicator: FC<TypingIndicatorProps> = ({ className }) => {
  return (
    <Box className={`${styles.typingMessage} ${className || ''}`}>
      <Box className={styles.aiIcon}>
        <AIRobotIcon size={32} />
      </Box>
      <Box className={styles.messageContent}>
        <Box className={styles.messageBubble}>
          <Box className={styles.typingIndicator}>
            <Box className={styles.dot} />
            <Box className={styles.dot} />
            <Box className={styles.dot} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TypingIndicator;
